export const TrackFAQ = [
    {
        id: '1',
        title: 'What are tracks?',
        description:
            'Tracks are hard skill learning paths. We have 2 currently; entrepreneurship and internship. Each of these tracks have a northstar you’ll work towards. Time to put all those soft skills to use by trying your hand out at either of these tasks. ',
    },
    {
        id: '2',
        title: 'What is the entrepreneurship track?',
        description:
            'The entrepreneurship track teaches you everything you need to know about starting your own business. From ideation to market research to finding suppliers and selling. Once you’re done with the track, you can apply to participate in the Ascend Now Bullpen! ',
    },
    {
        id: '3',
        title: 'What is the Bullpen?',
        description:
            'The bullpen is our version of the sharktank. Once you’re done with the entrepreneurship track, you can apply to participate in the bullpen. We’ll review your application and all the challenges and modules you’ve done. If you’re selected and you win, you can get up to $10,000 in funding and mentorship to make your business a reality. ',
    },
    {
        id: '4',
        title: 'What is the Internship track?',
        description:
            'The internship track teaches you everything you need to know about getting an internship. From building your resume and LinkedIn profile, to being an awesome intern! You’ll also be able to use the job board to find internship opportunities. Although, it is highly recommended you complete the internship track before you do so. ',
    },
];
